import { render } from "./CreateOrUpdateQuizQuestionOptionModal.vue?vue&type=template&id=12444312"
import script from "./CreateOrUpdateQuizQuestionOptionModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateQuizQuestionOptionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__